(function () {
	'use strict';

	var initiativeChartProperties = {
		'projectSavingsByAreaAndStage': { // must match the chart type in the API call
			eventName: 'event:projectSavingsByAreaAndStageCtrl:getChart', // event watched by directive
			fmtService: 'currencyFormatService' // Formatting service used for the values of the chart
		},
		'initiativeCountByStages': {
			eventName: 'event:initiativeCountByStages:getChart',
			fmtService: 'integerFormatService'
		},
		'projectSavingsBySiteAndStage': {
			eventName: 'event:projectSavingsBySiteAndStageCtrl:getChart',
			fmtService: 'currencyFormatService'
		},
		'projectSavingsByBusinessUnitAndStage': {
			eventName: 'event:projectSavingsByBusinessUnitAndStage:getChart',
			fmtService: 'currencyFormatService'
		}
	};

	angular.module('widgets.initiative', ['adf.provider'])
		.config(function (dashboardProvider) {

			var widgetStagesCountIncrease = {
				name: 'Summary of Lean Project Savings by Area',
				description: 'Summarizes the total target annual and one-time savings per lean project area & stage in a stacked bar chart.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/Number-of-Initiatives-by-Category.jpg',
				categories: ['All', 'Lean Projects'],
				config: {},
				slideshowView: true,
				isActive: false,
				templateUrl: '/application/f/dashboard/widgets/initiative_stages_count.html',
				reload: true,
				isDrillDown: false,
				resolve: {
					title: function (config) {
						if (config.title) {
							return config.title;
						}
					},
					type: function (config) {
						if (config.type) {
							return config.type;
						}
					}
				}
			};

			var widgetInitiativeCountIncrease = {
				templateUrl: '/application/f/dashboard/widgets/initiative_stages_count.html',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/Number-of-Initiatives-by-Category.jpg',
				categories: ['All', 'Lean Projects'],
				config: {},
				reload: true,
				isDrillDown: false,
				slideshowView: true,
				isActive: false,
				controller: 'genericInitiativeCtrl',
				resolve: {
					title: function (config) {
						if (config.title) {
							return config.title;
						}
					},
					type: function (config) {
						if (config.type) {
							return config.type;
						}
					}
				}
			};

			// register Initiative Widgets
			dashboardProvider
				.widget('projectSavingsByAreaAndStage', angular.extend({
					controller: 'genericInitiativeCtrl'
				}, widgetStagesCountIncrease))
				.widget('initiativeCountByStages', angular.extend({
					name: 'Number of Lean Projects by Area',
					description: 'The total number of projects per area, grouped by stage.'
					
					
				}, widgetInitiativeCountIncrease))
				.widget('projectSavingsBySiteAndStage', angular.extend({
					name: 'Summary of Lean Project Savings by Site',
					description: 'Summarizes the total target annual and one-time savings per lean project site & stage in a stacked bar chart.'
				}, widgetInitiativeCountIncrease))
				.widget('projectSavingsByBusinessUnitAndStage', angular.extend({
					name: 'Summary of Lean Project Savings by Business Unit',
					description: 'Summarizes the total target annual and one-time savings per lean project business unit & stage in a stacked bar chart.'
				}, widgetInitiativeCountIncrease));
		})

		.controller('genericInitiativeCtrl',
			function ($scope, $timeout, config, getJsonData, title, type, dashboardFilterInitializationService,
				$rootScope, URLS, pageTimingService, leanFilterService, storeService, leanProjectSummaryService) {
				$scope.filterService = dashboardFilterInitializationService;
				$scope.leanFilterService = leanFilterService;
				$scope.slideshowView = $rootScope.slideshowView;
				$scope.chartId = type;
				$scope.chartTitle = title;
				$scope.currentMode = 'Target';
				$scope.otherMode = 'Actual';
				$scope.groupBy = 'Areas';
				$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
				
				if (config.mode && config.mode === 'Actual') {
					$scope.currentMode = 'Actual';
					$scope.otherMode = 'Target';
				}
				$scope.testConfig = config;
				//load the chart properties based on the chart type
				var chartProps = initiativeChartProperties[$scope.chartId];
				if (chartProps.eventName === 'event:initiativeCountByStages:getChart') {
					$scope.isCount = true;
					$scope.currentMode = 'Count';
				} else if (chartProps.eventName === 'event:projectSavingsBySiteAndStageCtrl:getChart') {
					$scope.groupBy = 'Sites';
				} else if (chartProps.eventName === 'event:projectSavingsByBusinessUnitAndStage:getChart') {
					$scope.groupBy = 'BusinessUnit';
				}

				$scope.toggleMode = toggleMode;
				$scope.$parent.$parent.showViewReport = true;

				$scope.showTable = false;
				$scope.toggleTable = getTable;
				$scope.currencySymbol = $rootScope.currencySymbol;
				// toggles between 'Target' and 'Actual'
				function toggleMode() {
				// swap mode
					var temp = $scope.currentMode;
					$scope.currentMode = $scope.otherMode;
					$scope.otherMode = temp;
					// save config
					var widget = $scope.$parent.model;
					widget.config.mode = $scope.currentMode;
					var columnDefinition = $scope.$parent.$parent.col;
					storeService.dispatch({
						type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
						payload: {
							column: 'column' + columnDefinition.columnIndex,
							position: columnDefinition.widgets.indexOf(widget),
							widget: {
								name: widget.config.type,
								config: _.cloneDeep(widget.config)
							}
						},
						meta: {
							reportName: undefined,
							reportSettingsId: globalReportName
						}
					});
					getChart();
					if ($scope.showTable) {
						getTable();
					}
				}

				function getChart() {
					var url = URLS.host + URLS.prefix + '{0}/SummaryOfInitiative';
					var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true);
					filterQueryParams['type'] = $scope.currentMode;
					filterQueryParams['groupBy'] = $scope.groupBy;
					url = addQueryParam(url, $scope.leanFilterService.getFactoryList(), filterQueryParams, false);
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					getJsonData.get(url).then(
						function (d) {
							$scope.empty = false;
							if (!d || !d.data.length || !d.data[0]) {
								$scope.empty = true;
							} else {
								$scope.currencySymbol = d.targetCurrency ? d.targetCurrency : $rootScope.currencySymbol;
								var data = [];
								var stages = d.stages;
								var categories = [];
								var categoriesToId = {};
								var initiativeCount = 0;
								var totalSavings = 0;
								angular.forEach(d.data, function (chartData) {
									categories.push(chartData.code);
									categoriesToId[chartData.code] = chartData.id;
									initiativeCount += chartData.initiativeCount;
									totalSavings += chartData.totalSavings;
									delete chartData.code;
									delete chartData.initiativeCount;
									delete chartData.totalSavings;
								});
								$scope.chartData = d.data;
								$scope.chartCategories = categories;
								$scope.chartGroups = stages;
								$scope.initiativeCount = initiativeCount;
								$scope.totalSavings = totalSavings;
								$scope.categoriesCount = categories.length;
								$scope.targetCurrency = d.targetCurrency;
								$scope.categoriesToId = categoriesToId;
								$scope.$broadcast(chartProps.eventName, null);
							}
							if (!$scope.slideshowView) {
								pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
							}
						},
						function (e) {
							$scope.empty = true;
							if (!$scope.slideshowView) {
								pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
							}
						}
					);
				}

				$scope.tableUrl = function () {
					return '/application/f/dashboard/widgets/lean-project-areas-table.html';
				};

				$scope.getEncodedValue = function(rawString) {
					return encodeURIComponent(rawString);
				};

				function getTable() {
					var url = URLS.host + URLS.prefix + '{0}/TopLeanProjectAreas';
					var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true);
					filterQueryParams['type'] = $scope.currentMode;
					filterQueryParams['groupBy'] = $scope.groupBy;
					url = addQueryParam(url, $scope.leanFilterService.getFactoryList(), filterQueryParams, false);
					if (!$scope.showTable) {
						$scope.loadingTable = true;
						getJsonData.get(url).then(
							function (d) {
								var archivedStageIds = null;
								if ($scope.filterService.getSelected('Lean Project Stage')) {
									archivedStageIds = $scope.filterService.getSelected('Lean Project Stage');
								} else {
									archivedStageIds = leanProjectSummaryService.getArchiveStageIds($scope.filterService.getObjectList('Lean Project Stage'));
									if (archivedStageIds.length == 0) {
										archivedStageIds = null;
									}
								}
								filterQueryParams = {
									'timePeriod': $scope.filterService.getSelected('Time Period'),
									'projectManagerId': $scope.filterService.getSelected('Lean Project Manager'),
									'projectType': $scope.filterService.getSelected('Lean Project Type'),
									'projectCategoryId': $scope.filterService.getSelected('Lean Project Category'),
									'projectGoalId': $scope.filterService.getSelected('Lean Project Goals'),
									'projectSavingsCategoryId': $scope.filterService.getSelected('ProjectSavingsCategories')
								};
								if (archivedStageIds) {
									filterQueryParams['stageId'] = archivedStageIds;
								}
								if ($scope.groupBy === 'Areas' || $scope.groupBy === 'BusinessUnit') {
									filterQueryParams['factory'] = $scope.filterService.getSelected('Factory');
								}
								if ($scope.groupBy !== 'Areas') {
									filterQueryParams['projectArea'] = $scope.filterService.getSelected('Lean Project Area');
								}
								filterQueryParams = jQuery.extend(true, {}, filterQueryParams);
								$scope.extraFilters = getQueryParam(filterQueryParams, false);
								$scope.data = d;
								$scope.empty = false;
								$scope.loadingTable = false;
								$scope.showTable = !$scope.showTable;
							},
							function (e) {
								$scope.error = e;
								$scope.loadingTable = false;
								$scope.showTable = !$scope.showTable;
							}
						);
					} else {
						$scope.showTable = !$scope.showTable;
					}
				}

				updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
					'slideshowViewChanged', 'leanProjectFilterChanged'
				]);
				var loadData = function () {
					if (!dashboardFilterInitializationService.updating['initialLoad']) {
						var columnDefinition = $scope.$parent.$parent.col;
						var curWidget = $scope.$parent.model;
						if (!$scope.slideshowView) {
							dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						getChart();
					} else {
						$timeout(loadData, 100);
					}
				};
				loadData();
			}
		)

		.directive('genericInitiativeWidget', ['$compile', '$window', '$rootScope',
			'getJsonData', 'currencyFormatService', 'numberFormatService',
			'integerFormatService', '$translate', '$filter', 'leanFilterService', 'leanProjectSummaryService',
			function ($compile, $window, $rootScope, getJsonData,
				currencyFormatService, numberFormatService, integerFormatService,
				$translate, $filter, leanFilterService, leanProjectSummaryService) {

				// current services that are being used, will need to add them to this object if we add more
				var services = {
					'currencyFormatService': currencyFormatService,
					'numberFormatService': numberFormatService,
					'integerFormatService': integerFormatService
				};

				return {
					restrict: 'A',
					scope: {
						chartId: '@chartId'
					}, //chartId passed in from controller via HTML
					link: function (scope, elem, attrs) {
						//get the window width to help with responsiveness
						var chart;
						var targetCurrency;
						var categoryTimeOut;
						var w = angular.element($window);
						var width = Math.max(w.width(), window.innerWidth);
						var patternColors = ['#005DA7', '#0082E5', '#79C3FC', '#D7D7D7', '#9675E2'];
						scope.height = window.innerHeight;

						elem[0].id = elem[0].id + scope.$id;
						var scopeAccessor = scope.$parent.$parent;
						var groupBy = scopeAccessor.groupBy;
						var baseWidgetHeight = 250;
						var slideshow = false;
						scope.paddingTop = 4;
						var categoryMap = {};

						if (jQuery(elem[0]).parents('.slideshowWidget').length) {
							baseWidgetHeight = scope.height - 130;
							scope.paddingTop = 8;
							slideshow = true;
						}

						if (width > 992) {
							scope.paddingRt = slideshow ? 58 : 45;
							scope.paddingLt = slideshow ? 260 : 180;
							scope.rectSide = slideshow ? 14 : 10;
							scope.fontSize = slideshow ? '14px' : '10px';
						} else if (width >= 768) {
							scope.paddingRt = slideshow ? 58 : 35;
							scope.paddingLt = slideshow ? 260 : 180;
							scope.rectSide = slideshow ? 14 : 8;
							scope.fontSize = slideshow ? '14px' : '8px';
						} else {
							scope.paddingRt = slideshow ? 58 : 25;
							scope.paddingLt = slideshow ? 260 : 180;
							scope.rectSide = slideshow ? 14 : 6;
							scope.fontSize = slideshow ? '14px' : '6px';
						}

						scope.getWindowDimensions2 = function () {
							return {
								'w': Math.max(w.width(), window.innerWidth),
								'h': window.innerHeight
							};
						};
						// update on window resize
						scope.$watch(scope.getWindowDimensions2, function (newValue, oldValue) {
							scope.windowWidth2 = newValue.w;
							scope.height = newValue.h;
							var currentPaddingLeft = scope.paddingLt;
							if (scope.windowWidth2 >= 992) {
								scope.paddingRt = slideshow ? 58 : 45;
								scope.paddingLt = slideshow ? 260 : 180;
								scope.rectSide = slideshow ? 14 : 10;
								scope.fontSize = slideshow ? '14px' : '10px';
							} else if (scope.windowWidth2 >= 768) {
								scope.paddingRt = slideshow ? 58 : 35;
								scope.paddingLt = slideshow ? 260 : 180;
								scope.rectSide = slideshow ? 14 : 8;
								scope.fontSize = slideshow ? '14px' : '8px';
							} else {
								scope.paddingRt = slideshow ? 58 : 25;
								scope.paddingLt = slideshow ? 260 : 180;
								scope.rectSide = slideshow ? 14 : 6;
								scope.fontSize = slideshow ? '14px' : '6px';
							}

							if (slideshow) {
								baseWidgetHeight = scope.height - 200;
							}

							if (currentPaddingLeft !== scope.paddingLt || slideshow) {
								generateChart();
							}
						}, true);

						w.bind('resize', function () {
							scope.$apply();
						});

						//reading in the chart properties for this chart
						var chartKey = scope.chartId;
						var eventName = initiativeChartProperties[chartKey].eventName;
						var fmtService = services[initiativeChartProperties[chartKey].fmtService];
						var isCurrencyFormatService = initiativeChartProperties[chartKey].fmtService == 'currencyFormatService';
						var getStackSum = function (d) {
							var sum = 0;
							for (var prop in d) {
								if (d.hasOwnProperty(prop) && !isNaN(d[prop])) {
									sum += d[prop];
								}
							}
							return sum;
						};

						function addCategoriesTitle(elemId, groups) {
							var categoriesContainer = d3.selectAll(elemId + ' .c3-axis.c3-axis-x .tick')._groups[0];
							for (var i = 0; i < categoriesContainer.length; i++) {
								var categoryText = d3.select(categoriesContainer[i]).text();
								d3.select(categoriesContainer[i]).append('title').text(categoryMap[categoryText]);
							}
						}

						function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
							var $$ = this,
								config = $$.config,
								CLASS = $$.CLASS,
								titleFormat = config.tooltip_format_title || defaultTitleFormat,
								nameFormat = config.tooltip_format_name || function (name) {
									return name;
								},
								valueFormat = config.tooltip_format_value || defaultValueFormat,
								text, i, title, value, name, bgcolor;

							for (i = 0; i < d.length; i++) {
								if (!(d[i] && (d[i].value || d[i].value === 0))) {
									continue;
								}
								if (!text) {
									title = titleFormat ? titleFormat(d[i].x) : d[i].x;
									text = '<table class="' + CLASS.tooltip + '">' +
										(title || title === 0 ?
											'<tr><th colspan="2">' + categoryMap[title] + '</th></tr>' :
											'');
								}
								value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
								if (value !== undefined) {
									text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
									text += '<td class="name"><span style="background-color:' + color(d[i]) + '"></span>' +
										$translate.instant(d[i].name) + '</td>';
									text += '<td class="value">' + value + '</td>';
									text += '</tr>';
								}
							}
							return text + '</table>';
						}

						function addhyperlinks(elemId, categories, groupBy, chartCategoriesToId) {
							var kanbanUrl = '/application/f/home.html#/lean-projects/projects-kanban/?drilldown=1&' +
								(groupBy == 'Areas' ? 'projectArea':
									groupBy == 'BusinessUnit' ? 'businessunit' :'factory') + '=';
							d3.selectAll(elemId + ' .c3-axis.c3-axis-x .tick tspan')
								.on('click', function (d, i) {
									var savingsType = scopeAccessor.currentMode;
									if (savingsType === 'Count') {
										savingsType = 'Target';
									}
									savingsType = savingsType + ' Total Savings';
									var filters = scopeAccessor.filterService;
									var timePeriodParams = leanFilterService.getTimePeriodFilterQueryParam('timePeriod', filters.getSelected('Time Period'), true, true);
									var archivedStageIds = null;
									if (filters.getSelected('Lean Project Stage')) {
										archivedStageIds = filters.getSelected('Lean Project Stage');
									} else {
										archivedStageIds = leanProjectSummaryService.getArchiveStageIds(filters.getObjectList('Lean Project Stage'));
										if (archivedStageIds.length == 0) {
											archivedStageIds = null;
										}
									}
									var queryParams = {
										'projectManagerId': filters.getSelected('Lean Project Manager'),
										'projectType': filters.getSelected('Lean Project Type'),
										'projectCategoryId': filters.getSelected('Lean Project Category'),
										'projectSavings': savingsType,
										'projectGoalId': filters.getSelected('Lean Project Goals'),
										'projectSavingsCategoryId': filters.getSelected('ProjectSavingsCategories')
									};
									if (archivedStageIds) {
										queryParams['stageId'] = archivedStageIds;
									}
									queryParams = _.merge(queryParams, timePeriodParams);
									if (groupBy == 'Areas') {
										queryParams['factory'] = filters.getSelected('Factory');
										if (filters.getSelected('Business Unit')) {
											queryParams['businessunit'] = filters.getSelected('Business Unit');
										}
									} else if (groupBy == 'BusinessUnit') {
										queryParams['projectArea'] = filters.getSelected('Lean Project Area');
									} else {
										queryParams['projectArea'] = filters.getSelected('Lean Project Area');
									}
									var url = addQueryParam(kanbanUrl +
										encodeURIComponent((groupBy == 'Areas' || groupBy == 'BusinessUnit' ?
											categories[d.splitted]: chartCategoriesToId[categories[d.splitted]])),
									filters.getSelected('Factory'), queryParams);
									window.open(url, '_blank');
								});
						}
						var groupsState = {};

						function generateChart() {
							var data = scopeAccessor.chartData;
							var groups = scopeAccessor.chartGroups;
							var chartCategories = scopeAccessor.chartCategories;
							var chartCategoriesToId = scopeAccessor.categoriesToId;
							targetCurrency = scopeAccessor.targetCurrency;
							var categories = [];

							// abbreviate the vertical axis labels to fit
							var limitLabelWidth = slideshow ? 225 : 165;
							var tempSvg = d3.select('body').append('svg');
							var tempTextElement = tempSvg.append('text');
							angular.forEach(chartCategories, function (category) {
								var tempCategory = category;
								tempTextElement.text(tempCategory);
								var trimAmount = 0;
								var textSize = tempTextElement.node().getBBox();
								// font isn't monospace, so have to draw and measure the text to trim to a given width
								while (textSize.width > limitLabelWidth) {
									trimAmount += 1;
									tempCategory = category.substring(0, category.length - trimAmount) + '..';
									tempTextElement.text(tempCategory);
									textSize = tempTextElement.node().getBBox();
								}
								categoryMap[tempCategory] = category;
								categories.push(tempCategory);
							});
							tempTextElement.remove();
							tempSvg.remove();

							angular.forEach(groups, function (group) {
								groupsState[group] = true;
							});

							if (!data) {
								return;
							}

							var tickValues = [];
							if (scope.chartId === 'initiativeCountByStages') {
								// count projects in areas and generate tick values
								var maxProjectCount = 0;
								var i;
								for (i = 0; i < data.length; i++) {
									var projectCount = 0;
									for (var j = groups.length - 1; j >= 0; j--) {
										projectCount += data[i][groups[j]];
									}
									if (projectCount > maxProjectCount) {
										maxProjectCount = projectCount;
									}
								}
								var interval = 1;
								if (maxProjectCount > 12) {
									interval = maxProjectCount / 6;
								}
								for (i = 0; i <= maxProjectCount; i += interval) {
									tickValues.push($filter('number')(i, 0));
								}
								if (parseInt(tickValues[tickValues.length - 1]) !== maxProjectCount) {
									tickValues.push($filter('number')(maxProjectCount, 0));
								}
							}

							var config = {};
							config.bindto = '#' + elem[0].id;
							config.data = {};
							config.data.keys = {
								value: groups
							};

							config.data.json = data;
							config.data.type = 'bar';
							config.data.order = null;
							config.data.labels = {
								format: function (v, id, i, j) {
									if (v > 0) {
										return isCurrencyFormatService ? fmtService.get(v, targetCurrency) : fmtService.get(v);
									}
								}
							};
							config.data.labels = false;
							config.data.groups = [groups];
							config.padding = {
								right: scope.paddingRt,
								left: scope.paddingLt,
								top: scope.paddingTop,
								bottom: scope.paddingTop
							};
							config.axis = {};
							config.axis.x = {
								type: 'category',
								categories: categories,
								tick: {
									multiline: false
								}
							};
							var yAxisMin = d3.min([0, d3.min(data, getStackSum)]);
							config.axis.y = {
								tick: {
									format: function (v, id, i, j) {
										if (v) {
											return isCurrencyFormatService ? fmtService.get(v, targetCurrency) : fmtService.get(v);
										}
									},
									count: slideshow ? 10 : 5,
									multiline: false,
									outer: false
								},
								min: yAxisMin,
								max: d3.max(data, getStackSum),
								padding: {
									bottom: 0
								}
							};
							if (scope.chartId === 'initiativeCountByStages') {
								config.axis.y.tick.values = tickValues;
							}
							config.axis.rotated = true;
							config.size = {};
							var widgetHeight = baseWidgetHeight;
							if (!slideshow && data.length > 10) {
								widgetHeight += (data.length - 10) * 10;
							}
							config.size.height = widgetHeight;
							config.legend = {};
							config.legend.show = true;
							config.grid = {
								x: {
									show: false
								},
								y: {
									show: true
								}
							};
							if (yAxisMin < 0) {
								config.grid.y.lines = [{
									value: 0,
									text: 0,
									position: 'middle'
								}];
							}
							config.color = {
								pattern: patternColors
							};
							config.tooltip = {
								contents: tooltipFormat
							};

							// Change area labels to drilldown links
							config.onrendered = function () {
								jQuery('#' + elem.attr('id') + ' .c3-xgrid-lines')
									.prependTo(jQuery('#' + elem.attr('id') + ' .c3-grid').first());
								addhyperlinks(config.bindto, categoryMap, groupBy, chartCategoriesToId);
							};

							chart = c3.generate(config);
							categoryTimeOut = setTimeout(function () {
								addCategoriesTitle(config.bindto, scopeAccessor.chartGroups);
							}, 1000);
						}

						var generateListener = scope.$on(eventName, function (event) {
							generateChart();
							// setLegendsGapAndSize('#' + elem[0].id);
						});

						scope.$on('$destroy', function () {
							if (chart) {
								chart.destroy();
							}
							if (generateListener) {
								generateListener();
							}
							clearTimeout(categoryTimeOut);
						});
					}
				};
			}
		]);
})();
